<template>
  <!-- 出单活动配置弹框 -->
  <div>
    <Form ref="form" :model="formData" :label-width="100" class="page-form">
      <FormItem prop="type" label="活动类型" :rules="$units.formRule.required('请选择')" class="half" label-position="left">
        <RadioGroup v-model="formData.type" @on-change="changeType">
          <Radio label="1" :disabled="formData.status == '1' || formData.status == '-1'">增员活动（直接推荐人）</Radio>
          <Radio label="2" :disabled="formData.status == '1' || formData.status == '-1'">出单活动（业务员）</Radio>
          <Radio label="3" :disabled="formData.status == '1' || formData.status == '-1'">签约活动</Radio>
          <Radio label="4" :disabled="formData.status == '1' || formData.status == '-1'" v-if="$units.isOkBao()">报名活动</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem prop="mode" label="活动方式" :rules="$units.formRule.required('请选择活动方式')" class="half" key="mode2">
        <template #label>
          <span>
            活动方式
            <Tooltip transfer max-width="1000">
              <Icon type="md-help-circle" style="color: #a8adb7" size="16" />
              <template #content>
                <p>无门槛：没有条件，只要符合活动类型即可获奖</p>
                <p>梯度：活动有指标，需设置区间，达到对应条件才能获奖</p>
              </template>
            </Tooltip>
          </span>
        </template>
        <RadioGroup v-model="formData.mode" @on-change="changeMode">
          <Radio label="1" :disabled="formData.status == '1' || formData.status == '-1'">无门槛</Radio>
          <Radio label="2" :disabled="formData.status == '1' || formData.status == '-1'">梯度</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem prop="rewardType" label="奖励类型" :rules="$units.formRule.required('请选择')" class="half">
        <RadioGroup v-model="formData.rewardType" @on-change="changeRewardType">
          <Radio label="1" :disabled="formData.status == '1' || formData.status == '-1'">加费</Radio>
          <Radio label="3" :disabled="formData.status == '1' || formData.status == '-1'" v-if="formData.mode == 2">现金</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem prop="calFactor" label="计算因子" :rules="$units.formRule.required('请选择')" v-if="formData.rewardType != 3" class="half" :label-width="77">
        <RadioGroup v-model="formData.calFactor" @on-change="$emit('typeChange', formData)">
          <Radio label="2" :disabled="formData.status == '1' || formData.status == '-1'">业务员规保</Radio>
          <Radio label="1" :disabled="formData.status == '1' || formData.status == '-1'">业务员标保</Radio>
          <Radio label="3" :disabled="formData.status == '1' || formData.status == '-1'">业务员费用</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem
        key="conditionalIndicator"
        prop="conditionalIndicator"
        label="条件指标"
        :rules="$units.formRule.required('请选择')"
        v-show="formData.mode == 2"
        class="half"
        :label-width="formData.rewardType == 1 ? 100 : 77"
      >
        <RadioGroup v-model="formData.conditionalIndicator" @on-change="changeConditionalIndicator" @on-select="selectConditionalIndicator">
          <Radio label="2" :disabled="formData.status == '1' || formData.status == '-1'">累计规保</Radio>
          <Radio label="3" :disabled="formData.status == '1' || formData.status == '-1'">累计标保</Radio>
          <Radio label="4" :disabled="formData.status == '1' || formData.status == '-1'">累计保单数</Radio>
          <Radio label="5" :disabled="formData.status == '1' || formData.status == '-1'">累计费用</Radio>
          <Radio label="6" :disabled="formData.status == '1' || formData.status == '-1'">保单标保</Radio>
          <Radio label="7" :disabled="formData.status == '1' || formData.status == '-1'">保单规保</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem
        key="productType"
        prop="productType"
        label="产品类型"
        :rules="$units.formRule.required('请选择')"
        class="half"
        :label-width="formData.mode == 2 && formData.rewardType != 3 ? 77 : 100"
      >
        <RadioGroup
          v-model="formData.productType"
          @on-change="$emit('typeChange', formData), delFormData('endorsementIsJoin'), $bus.$emit('resetList', formData)"
        >
          <Radio label="1" :disabled="formData.status == '1' || formData.status == '-1' || !!id">个险</Radio>
          <Radio label="2" :disabled="formData.status == '1' || formData.status == '-1' || !!id">团险</Radio>
        </RadioGroup>
      </FormItem>

      <FormItem
        prop="calculateType"
        label="计算方式"
        :label-width="formData.rewardType == 1 ? 124 : 100"
        :rules="$units.formRule.required('请选择')"
        class="half"
        v-if="formData.mode == '2'"
      >
        <template #label>
          <span>
            计算方式
            <Tooltip transfer max-width="1000" placement="bottom-start">
              <Icon type="md-help-circle" style="color: #a8adb7" size="16" />
              <template #content>
                <p>系统统计：系统自动统计符合活动条件的保单，在参与详情里可查看保单详情</p>
                <p>人工导入：线下的活动通过人工导入保单的形式留存至系统，导入后无需业务员报名或配置参与组织，参与详情为您人工导入的保单数据</p>
              </template>
            </Tooltip>
          </span>
        </template>
        <RadioGroup v-model="formData.calculateType" @on-change="$emit('typeChange', formData)">
          <Radio label="0" :disabled="formData.status == '1' || formData.status == '-1'">系统统计</Radio>
          <Radio label="1" :disabled="formData.status == '1' || formData.status == '-1'">人工导入</Radio>
        </RadioGroup>
      </FormItem>

      <FormItem
        prop="joinType"
        label="参与方式"
        :rules="$units.formRule.required('请选择')"
        :label-width="formData.rewardType == 1 ? 100 : 120"
        key="joinType"
        v-if="[3, 6, 7].includes(formData.conditionalIndicator*1) && formData.mode == 2 && formData.calculateType != '1'"
        class="half"
      >
        <template #label>
          <span>
            参与方式
            <Tooltip transfer max-width="1000">
              <Icon type="md-help-circle" style="color: #a8adb7" size="16" />
              <template #content>
                <p>参与方式为全部参加时，活动期间内符合条件下业务员所有保单都参与活动，参与方式为首单时，活动期间内符合条件下业务员的首单参与活动。</p>
                <p>首单指的是活动期间内第一次投保时出的保单，如若活动期间内退保将自动替换成第二单，以此类推</p>
              </template>
            </Tooltip>
          </span>
        </template>
        <RadioGroup v-model="formData.joinType" @on-change="$emit('typeChange', formData)">
          <Radio label="1" :disabled="formData.status == '1' || formData.status == '-1'">全部参与</Radio>
          <Radio label="2" :disabled="formData.status == '1' || formData.status == '-1'">仅首单参与</Radio>
        </RadioGroup>
      </FormItem>

      <FormItem
        prop="needSignup"
        label="业务员参与方式"
        :rules="$units.formRule.required('请选择')"
        class="half"
        :label-width="165"
        v-if="formData.mode == 2 && formData.calculateType == '0'"
      >
        <template #label>
          <span>
            业务员参与方式
            <Tooltip transfer max-width="1000" placement="bottom-start">
              <Icon type="md-help-circle" style="color: #a8adb7" size="16" />
              <template #content>
                <p>
                  参与方式如果选择自动参加，参与机构下所有的业务员都参加此活动。<br />
                  如果选择业务员报名，参与机构下的所有业务员能看到此活动，但需要业务员点击立即参与按钮报名活动，报名成功的业务员才算活动奖励。
                </p>
              </template>
            </Tooltip>
          </span>
        </template>
        <RadioGroup v-model="formData.needSignup" @on-change="$emit('typeChange', formData)">
          <Radio label="0" :disabled="formData.status == '1' || formData.status == '-1'">自动参加</Radio>
          <Radio label="1" :disabled="formData.status == '1' || formData.status == '-1'">业务员报名</Radio>
        </RadioGroup>
      </FormItem>

      <FormItem
        prop="endorsementIsJoin"
        :label-width="![3, 6, 7].includes(formData.conditionalIndicator*1) && formData.mode == 2 ? 128 : 105"
        label="批单是否参加"
        :rules="$units.formRule.required('请选择')"
        v-if="formData.productType == 2"
        class="half"
      >
        <RadioGroup v-model="formData.endorsementIsJoin">
          <Radio label="0" :disabled="formData.status == '1' || formData.status == '-1'">否</Radio>
          <Radio label="1" :disabled="formData.status == '1' || formData.status == '-1'">是</Radio>
        </RadioGroup>
      </FormItem>
    </Form>
    <div class="tip" v-if="formData.mode == 2">
      <p class="title">配置说明：</p>
      <p>1、最大值和最小值都是包含当前数字，最大值可等于最小值；2、最后一条数据，条件指标最大值可以不填，最后结果为 最小值及以上</p>
    </div>
    <div class="table-box" v-if="formData.mode == 2">
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row, index }" slot="action" v-if="formData.status != '1' && formData.status != '-1'">
          <div class="detail">
            <div v-if="!row.isEdit" @click="row.isEdit = true">编辑</div>
            <div @click="delTable(index)">删除</div>
          </div>
        </template>

        <template slot-scope="{ row, column, index }" slot="input">
          <div v-if="compontntType == 'configModal'">
            <Input v-model="gradientConfigs[index][column.key]" :type="'text'" placeholder="请输入" v-if="row.isEdit" />
            <span v-else>{{ formData.rewardType == 3 ? gradientConfigs[index][column.key2] : gradientConfigs[index][column.key] }}</span>
          </div>
          <div v-else>
            <!-- <Input
              v-model="
                gradientConfigs[index][
                  column.key == 'rewardValue' ? (gradientConfigs[index].rewardSelect == 'kindReward' ? 'kindReward' : 'cashReward') : column.key
                ]
              "
              :type="column.key == 'rewardValue' && gradientConfigs[index].rewardSelect == 'cashReward' ? 'number' : 'text'"
              placeholder="请输入"
              v-if="row.isEdit"
            /> -->
            <InputNumber
              :min="0"
              :precision='2'
              :active-change="false"
              v-model="
                gradientConfigs[index][
                  column.key == 'rewardValue' ? (gradientConfigs[index].rewardSelect == 'kindReward' ? 'kindReward' : 'cashReward') : column.key
                ]
              "
              placeholder="请输入"
              v-if="row.isEdit"
            ></InputNumber>
            <div v-else>
              <span v-if="formData.status != '0'"
                >{{
                  gradientConfigs[index][
                    column.key == 'rewardValue' ? (gradientConfigs[index].rewardSelect == 'kindReward' ? 'kindReward' : 'cashReward') : column.key
                  ]
                }}
              </span>
              <span v-else>{{ formData.rewardType == 3 ? gradientConfigs[index][column.key2] : gradientConfigs[index][column.key] }}</span>
            </div>
          </div>
        </template>
      </Table>

      <div class="btn-item" style="margin-top: 10px">
        <Button type="warning" @click="addTable" :disabled="formData.status == '1' || formData.status == '-1'">新增</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { pageTool } from '@/api/mixins';
import _ from 'lodash';
export default {
  props: ['tableList', 'activityType', 'id', 'compontntType'],
  mixins: [pageTool],
  data() {
    return {
      formData: {
        type: '2',
        mode: '1',
        rewardType: '1',
        calFactor: '2',
        productType: '1',
        conditionalIndicator: '2',
        needSignup: '0',
        calculateType: '0'
      },
      tableData: [],
      gradientConfigs: [],
      isSupportFirstPolicy: sessionStorage.getItem('isSupportFirstPolicy'),
      columns: [
        {
          title: '条件指标最小值（元）',
          key: 'minValue',
          key2: 'minValue',
          align: 'center',
          slot: 'input'
        },
        {
          title: '条件指标最大值（元）',
          key: 'maxValue',
          key2: 'maxValue',
          align: 'center',
          slot: 'input'
        },
        {
          title: '奖励（%）',
          key: 'rateReward',
          key2: 'cashReward',
          align: 'center',
          slot: 'input',
          width: '200'
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center'
        }
      ]
    };
  },
  methods: {
    // 修改活动类型 TODO
    changeType(value) {
      const formData = JSON.parse(JSON.stringify(this.formData));
      if (formData.type == 1) {
        formData.rewardType = '1';
      } else if(formData.type == 2) {
        formData.mode = '1';
        formData.rewardType = [];
      } else if(formData.type == 3) {
        formData.mode = '2';
        formData.rewardType = [];
      }
      this.$emit('typeChange', formData);
      this.$bus.$emit('resetList', formData);
    },

    // 修改活动方式
    changeMode(value) {
      this.$emit('typeChange', this.formData);
      this.delFormData('joinType');
      this.$bus.$emit('resetList', this.formData);
      this.columns[2].title = '奖励（%）';
      if (value == 1) {
        this.formData.rewardType = '1';
      }
    },

    // 改变奖励类型
    changeRewardType(value) {
      this.$bus.$emit('resetList', this.formData);
      this.$emit('typeChange', this.formData);
      if (value == 3) {
        this.columns[2].title = '奖励（元）';
        if (this.$route.query.isAdd == '1') {
          this.formData.needSignup = '0';
        }
        this.formData.conditionalIndicator =
          this.formData.conditionalIndicator != '3' ||
          this.formData.conditionalIndicator != '4' ||
          this.formData.conditionalIndicator != '2' ||
          this.formData.conditionalIndicator != '5'
            ? this.formData.conditionalIndicator
            : '3';
      } else {
        this.columns[2].title = '奖励（%）';
        this.formData.conditionalIndicator = this.formData.conditionalIndicator ? this.formData.conditionalIndicator : '2';
      }
    },
    // 手动切换条件指标
    selectConditionalIndicator(){
      this.formData.joinType = '1';
    },
    changeConditionalIndicator(value) {
      if (this.formData.status == '0' || this.$route.query.isAdd == '1') {
        this.$emit('typeChange', this.formData);
      }
      this.columns.map((item, index) => {
        if (value == '4' && index == 0) {
          item.title = '条件指标最小值（件）';
        } else if (value == '4' && index == 1) {
          item.title = '条件指标最大值（件）';
        } else if (value != '4' && index == 0) {
          item.title = '条件指标最小值（元）';
        } else if (value != '4' && index == 1) {
          item.title = '条件指标最大值（元）';
        }
      });
    },
    getTableData() {
      if (this.id && this.formData.type == 2) {
        this.$http({
          url: '/buz/merchantActivity/queryGradientConfig',
          type: 'get',
          data: {
            id: this.id
          }
        }).then(res => {
          this.tableData = res.data.map(item => {
            item.maxValue = item.maxValue?Number(item.maxValue):null;
            item.minValue = Number(item.minValue);
            // 加费
            if(this.formData.rewardType==1) {
              item.rateReward  =  Number(item.rateReward);
              item.rewardSelect = 'cashReward';
            }else if(this.formData.rewardType==3){
              // 现金
              item.rateReward  =  Number(item.cashReward);
              item.rewardSelect = 'cashReward';
            }else {
              // 实物
              item.rewardValue =  item.kindReward;
              item.rewardSelect = 'kindReward';
            }
            return {
              ...item,
              isEdit: false
            };
          });
          this.gradientConfigs = res.data;
        });
      }
    },
    addTable() {
      this.tableData.push({
        isEdit: true
      });
      let data = {
        minValue: null,
        maxValue: null,  
        rateReward: null,
        cashReward: null,
      }
      this.gradientConfigs.push(data);
    },
    delTable(index) {
      this.tableData.splice(index, 1);
      this.gradientConfigs.splice(index, 1);
    },
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(valid => {
          if (valid) {
            try {
              console.log(this.gradientConfigs);
              this.gradientConfigs.map((item, index) => {
                if ((!item.minValue && item.minValue != 0) || (!item.rateReward&&item.rateReward!=0)) {
                  this.$notice.error(`请完善第${index + 1}行表格内容`);
                  throw new Error();
                } else if (item.maxValue && Number(item.minValue) > Number(item.maxValue)) {
                  this.$notice.error(`第${index + 1}行中，最小值需小于最大值`);
                  throw new Error();
                }
              });
              resolve({
                ...this.formData
              });
            } catch (error) {
              reject();
              console.log(error);
            }
          } else {
            reject();
          }
        });
      });
    },
    // 回显信息
    setData(data) {
      this.formData = {
        status: data.status,
        type: String(data.type),
        mode: String(data.mode),
        joinType: String(data.joinType ? data.joinType : ''),
        rewardType: String(data.rewardType ? data.rewardType : ''),
        calFactor: String(data.calFactor ? data.calFactor : ''),
        conditionalIndicator: String(data.conditionalIndicator ? data.conditionalIndicator : ''),
        productType: String(data.productType ? data.productType : ''),
        endorsementIsJoin: String(data.endorsementIsJoin == '0 ' || data.endorsementIsJoin == 1 ? data.endorsementIsJoin : ''),
        needSignup: String(data.needSignup == '0' || data.needSignup == '1' ? data.needSignup + '' : ''),
        calculateType: data.calculateType == '0' || data.calculateType == '1' ? data.calculateType + '' : ''
      };
      if (this.compontntType == 'addModal') {
        this.changeRewardType(data.rewardType);
        this.changeConditionalIndicator(data.conditionalIndicator);
      } else {
        if (data.conditionalIndicator == 4) {
          this.columns[0].title = '条件指标最小值（件）';
          this.columns[1].title = '条件指标最大值（件）';
        } else {
          this.columns[0].title = '条件指标最小值（元）';
          this.columns[1].title = '条件指标最大值（元）';
        }
        if (data.rewardType == 3) {
          this.columns[2].title = '奖励（元）';
        } else {
          this.columns[2].title = '奖励（%）';
        }
      }
      this.getTableData();
    },
    // 删除表单字段
    delFormData(key) {
      delete this.formData[key];
    }
  },
  watch: {
    tableList: {
      handler() {
        this.tableData = _.cloneDeep(this.tableList);
        this.gradientConfigs = _.cloneDeep(this.tableList);
      },
      immediate: true
    },
    activityType(newVal) {
      this.formData.type = newVal;
    }
  }
};
</script>
<style lang="scss" scoped>
.tip {
  display: flex;
  align-items: center;
  height: 40px;
  height: 40px;
  padding-left: 20px;
  background: #f7faff;
  border-radius: 4px;
  .title {
    font-weight: bold;
  }
  p {
    color: #3f6ec9;
    font-size: 12px;
  }
}
.btn-item {
  margin-bottom: 30px;
  display: flex;
}
/deep/ .ivu-radio-group-item {
  margin-right: 20px !important;
}
/deep/ .ivu-checkbox-group-item {
  margin-right: 20px !important;
}
</style>
